import React from "react";
import PropTypes from "prop-types";
import { RawHTML } from "../";

function PlaceHolder({
  placeHolders,
  component,
  location,
  disablePreLine = true
}) {
  const currentPlaceHolder =
    placeHolders &&
    placeHolders.length > 0 &&
    placeHolders.find(
      elem => elem.component == component && elem.location == location
    );
  const className = `${component}_${location}`;
  return currentPlaceHolder && currentPlaceHolder.content ? (
    <RawHTML
      disablePreLine={disablePreLine}
      html={currentPlaceHolder.content}
      className={className}
    />
  ) : (
    <div />
  );
}

PlaceHolder.propTypes = {
  placeHolders: PropTypes.array,
  component: PropTypes.string,
  location: PropTypes.string,
  disablePreLine: PropTypes.bool
};

PlaceHolder.defaultProps = {
  placeHolders: [],
  component: "",
  location: "",
  disablePreLine: true
};

export default PlaceHolder;



// WEBPACK FOOTER //
// ./src/components/common/PlaceHolder/PlaceHolder.js